var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c(
      "div",
      { staticClass: "featured-search" },
      [
        _c("advisor-carousel", {
          attrs: {
            zipcode: _vm.zipcode,
            longitude: _vm.longitude,
            latitude: _vm.latitude,
            advisortypecategory: _vm.advisortypecategory,
            labeltext: _vm.labeltext,
            blockid: _vm.blockid,
            hidezip: _vm.hidezip,
            locationcode: _vm.locationcode,
            headingtag: _vm.headingtag,
            advisorheadingtag: _vm.advisorheadingtag
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }